import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
const API = `${BACKEND_URL}/api`;

const urlBase64ToUint8Array = (b64) => {
  const padding = '='.repeat((4 - (b64.length % 4)) % 4);
  const base64 = (b64 + padding).replace(/-/g, '+').replace(/_/g, '/');
  const raw = atob(base64);
  const arr = new Uint8Array(raw.length);
  for (let i = 0; i < raw.length; i++) arr[i] = raw.charCodeAt(i);
  return arr;
};

export const pushSupported = () =>
  typeof window !== 'undefined' &&
  'serviceWorker' in navigator &&
  'PushManager' in window &&
  'Notification' in window;

export const getPushStatus = async () => {
  if (!pushSupported()) return 'unsupported';
  if (Notification.permission === 'denied') return 'denied';
  try {
    const reg = await navigator.serviceWorker.getRegistration('/sw.js');
    if (!reg) return 'idle';
    const sub = await reg.pushManager.getSubscription();
    return sub ? 'subscribed' : 'idle';
  } catch { return 'idle'; }
};

export const subscribeToPush = async () => {
  if (!pushSupported()) throw new Error('Push not supported on this device');

  const perm = await Notification.requestPermission();
  if (perm !== 'granted') throw new Error('Permission denied');

  const reg = await navigator.serviceWorker.register('/sw.js');
  await navigator.serviceWorker.ready;

  const { data } = await axios.get(`${API}/push/public-key`);
  const sub = await reg.pushManager.subscribe({
    userVisibleOnly: true,
    applicationServerKey: urlBase64ToUint8Array(data.public_key),
  });

  const json = sub.toJSON();
  await axios.post(`${API}/push/subscribe`, {
    endpoint: json.endpoint,
    keys: json.keys,
  });
  return 'subscribed';
};

export const unsubscribeFromPush = async () => {
  if (!pushSupported()) return;
  const reg = await navigator.serviceWorker.getRegistration('/sw.js');
  const sub = await reg?.pushManager.getSubscription();
  if (sub) {
    await axios.post(`${API}/push/unsubscribe`, { endpoint: sub.endpoint }).catch(() => {});
    await sub.unsubscribe();
  }
};
